/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="153.54"
        height="52.91"
        viewBox="0 0 153.54 52.91"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="m70.33 1.66.43-.09c.84-.18 1.69-.35 2.54-.5l1-.17c11.52-1.87 22.85-.83 27 3.33l4.32 4.35 4.58 4.66 1.66 1.69a1.25 1.25 0 1 1-1.78 1.75l-3.33-3.38-4.25-4.38-2-2.07-.86-.85c-3-3-11.59-4.11-21-3.15l-1 .11c-2.1.25-4.25.6-6.36 1.05l-.49.11-.54.13a65.13 65.13 0 0 0-41.4 33.29l-.28.56a4.6 4.6 0 0 0-.5 2.12 4.67 4.67 0 0 0 4.43 4.67h11.85a1.252 1.252 0 0 1 .15 2.5H32.74a7.17 7.17 0 0 1-7.17-7.18 7.07 7.07 0 0 1 .77-3.19A67.64 67.64 0 0 1 69.61 1.84l.61-.15ZM114.01 44.9a1.25 1.25 0 0 1 .13 2.49H64.21a1.25 1.25 0 0 1-.13-2.49h49.93Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M54.28 27.02a13 13 0 1 0 13 13 13 13 0 0 0-13-13Zm0 2.5a10.46 10.46 0 1 1-10.46 10.43A10.47 10.47 0 0 1 54.28 29.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M54.28 32.79a7.17 7.17 0 1 1 0 14.33 1 1 0 0 1 0-2 5.17 5.17 0 1 0-5.17-5.17 1 1 0 0 1-2 0 7.17 7.17 0 0 1 7.17-7.16Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M123.95 27.02a13 13 0 1 0 13 13 13 13 0 0 0-13-13Zm0 2.5a10.46 10.46 0 1 1-10.45 10.43 10.47 10.47 0 0 1 10.45-10.45Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M123.95 32.79a7.17 7.17 0 1 1 0 14.33 1 1 0 0 1 0-2 5.17 5.17 0 1 0-5.17-5.17 1 1 0 0 1-2 0 7.17 7.17 0 0 1 7.17-7.16ZM36.07 14.61a1.25 1.25 0 0 1 1.25 1.25 1.27 1.27 0 0 1-1.13 1.25h-21.4a1.25 1.25 0 0 1-.12-2.49h21.4ZM21.44 30.71a1.25 1.25 0 0 1 .12 2.49H7.21a1.25 1.25 0 0 1-.13-2.49h14.36ZM26.55 22.95a1.25 1.25 0 0 1 .13 2.49H1.25a1.252 1.252 0 0 1-.13-2.5h25.43Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="m144.4 20.59 1.85 1.68a6.39 6.39 0 0 0-1.75 4.32c0 3.68 3.27 6.73 7.41 6.85h.26v2.5c-5.59 0-10.17-4.16-10.17-9.35a8.9 8.9 0 0 1 2.14-5.75Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M125.92 14.59c10.3 0 17.66 2.76 22.28 7.72a20.19 20.19 0 0 1 5.3 13.45v3.26a8.42 8.42 0 0 1-8.18 8.4h-11.44a1.25 1.25 0 0 1-.13-2.49h11.36a5.92 5.92 0 0 0 5.93-5.67v-3a17.8 17.8 0 0 0-4.66-12.24c-4-4.32-10.56-6.82-19.9-6.92H44.82a1.252 1.252 0 0 1-.13-2.5h81.09Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'CarMovingIcon';

export default Icon;
